import React from 'react';
import Partner from './Partner';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'partner';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <Partner
        key={`${type}-${index}`}
        user={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
